import { lazy } from "react";
import type { RouteObject } from "react-router";

const DashboardPage = lazy(() => import("./views/dashboard"));

const tableRoutes: RouteObject = {
  id: "table",
  path: "/table",
  element: <DashboardPage />,
};

export default tableRoutes;
